import { module } from 'angular';

const mfParser = /* @ngInject */ (/** @type {import('angular').IParseService} */ $parse) => {
	const MF_REGEXP = /^\s*([\S\s]+?)(?:\s+as\s+([\S\s]+?))?\s+for\s+([\w$]+)\s+in\s+([\S\s]+?)$/;
	return {
		parse: (/** @type {string} */ input) => {
			const match = input.match(MF_REGEXP);
			if (!match) {
				throw new Error(
					`${'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"'
					+ ' but got "'}${input}".`,
				);
			}

			return {
				itemName: match[3],
				source: $parse(match[4]),
				viewMapper: $parse(match[2] || match[1]),
				modelMapper: $parse(match[1]),
			};
		},
	};
};

export default module('app')
	.factory('mfParser', mfParser);
